import { ReactElement } from "react";
import { IFormHandler } from "client/Forms";
import { localize } from "client_legacy/ndaw/culture";
import { ActivityFeedSettingsState } from "./NotificationSettingsDialog";
import { NotificationSection } from "./NotificationSection";

export type DocumentActivitySectionProps = {
	formHandler: IFormHandler<ActivityFeedSettingsState>;
};

export const DocumentActivitySection = (props: DocumentActivitySectionProps): ReactElement => {
	const { formHandler } = props;

	return (
		<NotificationSection
			title={localize("_FoldersAndFiles")}
			trackingId="folders-and-files"
		>
			<NotificationSection.ItemList>
				<NotificationSection.Item
					label={localize("_MovedCopiedItems")}
					subtext={localize("_MovedCopiedItemsActivityDescription")}
					attachable={formHandler.for("crossStoreOperations")
						.for("isEnabled")
						.attachToCheckbox()
					}
				/>

				<NotificationSection.Item
					label={localize("_SharedItems")}
					subtext={localize("_SharedItemsActivityDescription")}
					attachable={formHandler.for("documentShared")
						.for("isEnabled")
						.attachToCheckbox()
					}
				/>
			</NotificationSection.ItemList>
		</NotificationSection>
	);
};

DocumentActivitySection.displayName = "DocumentActivitySection";
